// Module
var code = "<template> <require from=\"app/cm/components/household/notes/notes-grid\"></require> <notes-grid household-case-id.bind=\"householdCaseId\" config.bind=\"config\"></notes-grid> </template> ";
// Exports
module.exports = code;